export const canWrite = (role) =>
  role === 'VENDOR' || role === 'EDITOR';

export const canWriteOrders = (role) =>
  role === 'VENDOR' || role === 'EDITOR' || role === 'EDITOR_ORDER_ONLY';

export const isVendor = (role) => role === 'VENDOR';

export const hasFullAccess = (role) =>
  role === 'VENDOR' || role === 'EDITOR' || role === 'VIEWER';
